import { FormControl, ValidatorFn } from "@angular/forms";
import { PixIdType, PixIdTypeValue } from '../model/types/vpa-type';
import { PATTERNS } from '../providers/myria/app-variables';


export class PixValidator {

    static checkPixError(control:FormControl):ValidatorFn {

        if(!control.parent || !control.parent.value['pIXIDType']) {
            return;
        }
        let pixIdType = control.parent.value['pIXIDType'];
        let returnVal : any;
        if(control.value) {
            switch(pixIdType) {
                case PixIdTypeValue.CPFNumber:
                    const unmaskedValue = control.value.replace(/\D/g, '');
                    if(!unmaskedValue.match(/^[0-9]+$/) || unmaskedValue.length != 11) {
                        returnVal = {'pixCPFError': true};
                    }
                    break;
                case PixIdTypeValue.EmailAddress:
                    if(!control.value.match(PATTERNS.EMAIL)){
                        returnVal = {'pixEmailError': true};
                    }
                    break;
                case PixIdTypeValue.PIXKey:
                    if(!control.value.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/) || control.value.length != 36) {
                        returnVal = {'pixKeyError': true};
                    }
                    break;
                case PixIdTypeValue.MobileNumber:
                    //const value = control.value.substring(3);
                    if(control.value.length && control.value.length !== 11){
                        returnVal = {'pixError' : 'pixError'};
                    }
                    else if(control.value.length === 0) {
                        returnVal = {'pixError': 'required'};
                    }
                    break;
            }
            return returnVal;
        }
    }
}


// WEBPACK FOOTER //
// ./src/validators/pixValidator.ts